import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const Hero = () => (
    <header style={{ paddingTop: '160px', paddingBottom: '80px', position: 'relative', overflow: 'hidden' }}>
        {/* Subtle Gradient Accents */}
        <div className="animate-float" style={{ position: 'absolute', top: '5%', left: '-5%', width: '500px', height: '500px', background: 'var(--accent-primary)', filter: 'blur(150px)', opacity: 0.15, borderRadius: '50%', zIndex: -1 }}></div>
        <div className="animate-float" style={{ position: 'absolute', top: '30%', right: '-10%', width: '600px', height: '600px', background: 'var(--accent-secondary)', filter: 'blur(150px)', opacity: 0.15, borderRadius: '50%', zIndex: -1, animationDelay: '2s' }}></div>

        <div className="container" style={{ textAlign: 'center', maxWidth: '900px', zIndex: 1, position: 'relative' }}>
            <div style={{ display: 'inline-block', padding: '6px 16px', background: 'rgba(255,255,255,0.05)', borderRadius: '24px', border: '1px solid var(--border-subtle)', marginBottom: '32px', color: 'var(--text-secondary)', fontSize: '0.875rem', fontWeight: 600, letterSpacing: '0.5px' }}>
                ✨ Built for modern hospitality
            </div>

            <h1 style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)', marginBottom: '24px', letterSpacing: '-0.02em', lineHeight: 1.1 }}>
                Stop Losing Customers Because <span className="text-gradient-accent">Service Was Too Slow.</span>
            </h1>

            <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)', marginBottom: '48px', maxWidth: '700px', margin: '0 auto 48px auto', lineHeight: 1.6 }}>
                Real-time table and room service system built for modern hospitality businesses.
            </p>

            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link to="/contact" className="btn btn-primary" style={{ padding: '16px 36px', fontSize: '1.125rem', textDecoration: 'none' }}>
                    Book Free Setup <ArrowRight size={20} style={{ marginLeft: '8px' }} />
                </Link>
                <Link to="/contact" className="btn btn-outline" style={{ padding: '16px 36px', fontSize: '1.125rem', textDecoration: 'none' }}>
                    Get Started Today
                </Link>
            </div>

            {/* Visual Mockup Area */}
            <div style={{ marginTop: '80px', position: 'relative', width: '100%', maxWidth: '1000px', margin: '80px auto 0 auto' }}>
                <div className="glass-panel" style={{ padding: '4px', borderRadius: '20px', border: '1px solid var(--border-focus)', background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.01) 100%)', boxShadow: '0 24px 64px rgba(0,0,0,0.4)' }}>
                    <div style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid var(--border-subtle)' }}>
                        <img src="/full_experience.png" alt="Ordabell Full Experience" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                    </div>
                </div>
            </div>
        </div>
    </header>
);
